import React from "react"
import "swiper/css"
import { Swiper, SwiperSlide } from "swiper/react"
import { Keyboard, Scrollbar, Navigation, Pagination, Autoplay } from "swiper"
import SliderItem from "./SliderItem"
import { CREDIT_LAYER_ENUM } from "../../../../../../services/requests/types"
import auth from "../../../../../../lib/auth"
import Pages from "src/constants/pages"

const sliderItems = [
  {
    title: "به سرعت جت، وام بگیر",
    img: "/images/icons/launch2.png",
    loanUrl: auth?.isLoggedIn ? Pages.Facilities : Pages.Login,
    description: " با جت وام آنلاین وام بگیر و از شبکه پذیرندگان متنوع بدون اتلاف وقت خرید کن",
    loanGuideUrl: Pages.LoanGuide
  },
  // {
  //   title: "طرح تعویض الکترو موتورهای کولر آبی",
  //   img: "/images/icons/air-conditioner-loan.webp",
  //   loanUrl: auth?.isLoggedIn
  //     ? `${Pages.Facilities}?creditLayerId=${CREDIT_LAYER_ENUM.AIR_CONDITIONER}`
  //     : `${Pages.Login}?backUrl=/main?creditLayerId=${CREDIT_LAYER_ENUM.AIR_CONDITIONER}`,
  //   description: "بزرگترین طرح بهره‌وری انرژی در صنعت‌ برق (ویژه مشترکین خانگی در سراسر کشور)",
  //   loanGuideUrl: `${Pages.LoanGuide}?creditLayerId=${CREDIT_LAYER_ENUM.AIR_CONDITIONER}`
  // }
]
const MainSlider = () => {
  return (
    <Swiper
      slidesPerView={1}
      centeredSlides={false}
      slidesPerGroupSkip={1}
      grabCursor={true}
      keyboard={{
        enabled: true
      }}
      navigation={true}
      pagination={{
        clickable: true
      }}
      autoplay={{
        delay: 7000,
        disableOnInteraction: false
      }}
      modules={[Autoplay, Keyboard, Scrollbar, Navigation, Pagination]}
      className='homeSlider'
    >
      {sliderItems.map((slider, index) => (
        <SwiperSlide key={index}>
          <SliderItem slider={slider} />
        </SwiperSlide>
      ))}
    </Swiper>
  )
}

export default MainSlider
